import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _VEHICLE_TYPE_VS_SOUR;

import { EMPTY_STRING } from 'tbase/app.constants';
import { DEAL_TYPES } from 'tbase/constants/deal/type';
import { DESCENDING, VEHICLE_TYPE, VEHICLE_SOURCE } from './constants';
import { MILEAGE_STATUS_OPTIONS } from './desking.constants';
export var PERSONAL = 'PERSONAL';
export var BUSINESS = 'BUSINESS';
export var BODY_STYLE_OPTIONS = [{
  value: 'coupe',
  label: 'Coupe'
}, {
  value: 'convertible',
  label: 'Convertible'
}, {
  value: 'sedan',
  label: 'Sedan'
}, {
  value: 'sportsUtility',
  label: 'Sports Utility'
}, {
  value: 'truck',
  label: 'Truck'
}];
export var LAYOUT = {
  DEAL_INFO_CONTENT: 116,
  TAB_BAR: 55,
  SELECTED_DATA_FOOTER: 102
};
export var INITIAL_CUSTOMER_STATE = {
  firstName: EMPTY_STRING,
  lastName: EMPTY_STRING,
  mobileNo: EMPTY_STRING,
  zipCode: EMPTY_STRING,
  email: EMPTY_STRING
};
export var INITIAL_VEHICLE_STATE = {
  locationCode: EMPTY_STRING,
  retailPrice: EMPTY_STRING,
  invoicePrice: EMPTY_STRING,
  vehicleType: VEHICLE_TYPE.NEW,
  sourceInfo: {
    source: VEHICLE_SOURCE.DEALER_TRADE
  },
  mileageStatus: MILEAGE_STATUS_OPTIONS.ACTUAL
};
export var VEHICLE_TYPE_BUTTONS = [{
  icon: 'icon-new-vehicle',
  label: __('New Vehicle'),
  value: VEHICLE_TYPE.NEW
}, {
  icon: 'icon-used-vehicle',
  label: __('Used Vehicle'),
  value: VEHICLE_TYPE.USED
}];
export var RIGHT_ALLIGNED_COLUMNS = ['retailPrice', 'invoicePrice', 'profit'];
export var CUSTOMER_TYPES = {
  BUYER: 'BUYER',
  CO_BUYER: 'CO_BUYER'
};
export var VEHICLE_COLUMN_WIDTHS = {
  stockID: 122,
  vin: 216,
  status: 122,
  year: 72,
  make: 106,
  model: 122,
  retailPrice: 132,
  mileage: 132,
  exteriorColor: 122,
  ageDays: 107,
  interiorColor: 122,
  driveType: 122,
  monthlyPayment: 181,
  vehicle: 160,
  activeDeals: 160,
  vehicleType: 130,
  invoicePrice: 132,
  trim: 175,
  vehicleSubType: 160
};
export var CUSTOMER_COLUMN_WIDTHS = {
  name: 300,
  dob: 200,
  customerType: 150,
  email: 240,
  homePhone: 180,
  workPhone: 180,
  activeDeals: 120
};
export var NEW_CUSTOMER = 'New Customer';
export var NEW_VEHICLE = 'New Vehicle';
export var PRICING_DETAIL_KEYS = ['retailPrice', 'invoicePrice', 'sellingPrice', 'msrp', 'glBalance', 'holdBackAmount', 'freightInPrice', 'airTaxPrice'];
export var COLUMNS_THAT_NEEDS_CUSTOM_ACCESSOR = ['retailPrice', 'invoicePrice', 'profit', 'driveType', 'msrp', 'dealerName'];
export var TAB_KEYS = {
  LEADS: '1',
  VEHICLE: '2',
  CUSTOMER: '3'
};
var AXIS = {
  X: 'x',
  Y: 'y'
};
export var CART_AXIS_CONTROLLER_PROPS = {
  axis: AXIS.X,
  lockAxis: AXIS.X,
  lockToContainerEdges: true
};
export var CATEGORY_1_DEAL_TYPES = [DEAL_TYPES.PERSONAL, DEAL_TYPES.BUSINESS, DEAL_TYPES.FLEET, DEAL_TYPES.INTERNET, DEAL_TYPES.HOUSE, DEAL_TYPES.EMPLOYEE_PURCHASE, DEAL_TYPES.REFINANCING];
export var CATEGORY_3_DEAL_TYPES = [DEAL_TYPES.DEALER_TRADE, DEAL_TYPES.WHOLESALE, DEAL_TYPES.INTERNAL_TRANSFER];
export var CATEGORY_2_DEAL_TYPES = [DEAL_TYPES.FNI];
export var CATEGORY_4_DEAL_TYPES = [DEAL_TYPES.ONLY_TRADES]; // export const VEHICLE_SEARCH_KEYS = {
//   ageDays: 'entryTime',
//   invoicePrice: 'pricingDetails.invoicePrice',
//   glBalance: 'pricingDetails.glBalance',
//   msrp: 'pricingDetails.msrp',
//   retailPrice: 'pricingDetails.retailPrice',
// };

export var DEFAULT_SORT = [{
  key: 'modifiedTime',
  field: 'modifiedTime',
  order: DESCENDING
}];
export var VEHICLE_TYPE_VS_SOURCE = (_VEHICLE_TYPE_VS_SOUR = {}, _defineProperty(_VEHICLE_TYPE_VS_SOUR, VEHICLE_TYPE.NEW, VEHICLE_SOURCE.DEALER_TRADE), _defineProperty(_VEHICLE_TYPE_VS_SOUR, VEHICLE_TYPE.USED, VEHICLE_SOURCE.AUCTION_OR_WHOLESALE), _VEHICLE_TYPE_VS_SOUR);
export var NOT_REQUIRED_KEYS_FOR_FNI_DEAL = ['accountNumber', 'glAccountNumber', 'pricingDetails.sellingPrice', 'pricingDetails.glBalance'];
export var MARKET_SCAN_ID_TO_USE = {
  MARKET_SCAN_ID: 'marketScanVehicleId',
  CHROME_STYLE_ID: 'styleId'
};